import * as React from "react";
import clsx from "clsx";
import { Fittext } from "../fittext/fittext.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../helpers/helper/hooks/use-responsive-props.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { Tooltip } from "../tooltip/tooltip.mjs";
const tagSizeFontSize = {
  tiny: "small",
  small: "large",
  medium: "extra-large",
  large: "small"
};
const TagTooltipButton = React.forwardRef(function TagTooltipButton2(props, ref) {
  const { id, children, className, onClick, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ...rest,
      ref,
      type: "button",
      id,
      className,
      onClick: (e) => {
        e.stopPropagation();
        onClick == null ? void 0 : onClick(e);
      }
    },
    children
  );
});
const Tag = (props) => {
  const { responsive, ...rest } = props;
  return responsive ? /* @__PURE__ */ React.createElement(TagResponsive, { ...rest, responsive }) : /* @__PURE__ */ React.createElement(TagInner, { ...rest });
};
const TagResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({
    responsive
  });
  return /* @__PURE__ */ React.createElement(TagInner, { ...rest, ...responsiveProps });
};
const _TagInner = class _TagInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0
    };
  }
  BEM() {
    const { size, purpose, icon, image, isDisabled, tooltip, className } = this.props;
    return clsx(
      "telia-tag",
      "telia-tag--".concat(size),
      {
        ["telia-tag--".concat(purpose)]: !!purpose,
        "telia-tag--icon": !!icon,
        "telia-tag--image": !!image,
        "telia-tag--disabled": !!isDisabled,
        "telia-tag--tooltip": !!tooltip
      },
      className
    );
  }
  renderIcon(icon) {
    return /* @__PURE__ */ React.createElement(Icon, { className: "telia-tag__icon", modifiers: icon });
  }
  renderText(item) {
    const classArray = ["telia-tag__text"];
    const { size } = this.props;
    const tagSizeFontSizeValue = tagSizeFontSize[size];
    if (item.image || item.icon && this.props.size !== "large" && this.props.size !== "tiny") {
      classArray.push("telia-tag__text--hidden");
    }
    if (item.fontSize) {
      classArray.push("telia-tag__text--" + item.fontSize);
    } else if (tagSizeFontSizeValue) {
      classArray.push("telia-tag__text--" + tagSizeFontSizeValue);
    }
    let tagTextContent;
    if (typeof item.text === "string" && this.props.size !== "tiny") {
      tagTextContent = /* @__PURE__ */ React.createElement(Fittext, null, item.text);
    } else {
      tagTextContent = item.text;
    }
    return /* @__PURE__ */ React.createElement("span", { className: classArray.join(" ") }, tagTextContent);
  }
  renderImage(image) {
    return /* @__PURE__ */ React.createElement(Image, { ...image, className: "telia-tag__image" });
  }
  renderContent(item) {
    const ContentElement = this.props.tooltip ? "span" : "div";
    return /* @__PURE__ */ React.createElement(ContentElement, { className: "telia-tag__content" }, item.icon && this.props.size !== "tiny" && this.renderIcon(item.icon), item.text && this.renderText(item), item.image && this.renderImage(item.image));
  }
  renderToolTipWrapper(defaultItem, tooltip) {
    const { id } = this.props;
    const { id: tooltipId, children, ...tooltipProps } = tooltip;
    return /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        ...tooltipProps,
        referenceElement: /* @__PURE__ */ React.createElement(TagTooltipButton, { id: tooltipId != null ? tooltipId : id, className: this.BEM() }, this.renderContent(defaultItem))
      },
      children
    );
  }
  renderDefaultWrapper(defaultItem) {
    const { id } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM(), id }, this.renderContent(defaultItem));
  }
  render() {
    const defaultItem = {
      fontSize: this.props.fontSize,
      icon: this.props.icon,
      image: this.props.image,
      text: this.props.text
    };
    const { tooltip } = this.props;
    return tooltip ? this.renderToolTipWrapper(defaultItem, tooltip) : this.renderDefaultWrapper(defaultItem);
  }
};
_TagInner.defaultProps = {
  size: "large"
};
let TagInner = _TagInner;
export {
  Tag
};
